import { Component, h, render } from "preact";
import {
  INJECT_WRAPPER_ELEMENT,
  PRODUCT_UID_ATTR,
} from "@/constants/selectors";

import Stars from "@/components/ProductRating/ProductRating";

/**
 * @param {*} productsJqElements
 * @param {*} logger
 */
export function injectRatingsInProuctCard(productsJqElements, logger) {
  logger.info("injectRatingsInProuctCard starts", { productsJqElements });

  productsJqElements.each((_, _productElement) => {
    const _productJqElement = $(_productElement);
    const productUid = _productJqElement.attr(PRODUCT_UID_ATTR);

    // Индикатор рейтинга в карточке товара
    const starsMiniEl = $(INJECT_WRAPPER_ELEMENT);
    _productJqElement.find(".t-store__card__title").before(starsMiniEl);
    render(<Stars productUid={productUid} />, starsMiniEl.get(0));
  });

  window.setTimeout(() => {
    window.setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 1);
  }, 1);

  logger.info("injectRatingsInProuctCard finish");
}
